import { Search } from '@mui/icons-material';
import styles from './SearchBar.module.css';

interface SearchBarProps {
	value: string;
	onChange: (q: string) => void;
	placeholder?: string;
}

export const SearchBar = ({ value, onChange, placeholder = 'Pesquise aqui...' }: SearchBarProps) => (
	<div className={styles.searchBar}>
		<Search sx={{ fontSize: '1.25rem' }} className={styles.searchIcon} />
		<input
			type="text"
			placeholder={placeholder}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			className={styles.searchInput}
		/>
	</div>
);
